import React from 'react';
import { PieChart, Pie, Cell, Tooltip, Legend, ResponsiveContainer } from 'recharts';

const Piechart = ({ data }) => {
    const COLORS = ['green','#0088FE', '#00C49F', '#FFBB28', '#FF8042'];

    return (
        <div style={{ display: 'flex', justifyContent: 'flex-start', marginTop:"20px" }}>
            <ResponsiveContainer width="60%" height={200}>
                <PieChart margin={{ left: 5 }}>
                    <Pie
                        data={data}
                        cx="40%" // Adjusted to move pie chart closer to the left
                        cy="50%"
                        innerRadius={60}
                        outerRadius={100}
                        fill="#8884d8"
                        paddingAngle={5}
                        dataKey="value"
                        // label
                    >
                        {data.map((entry, index) => (
                            <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                        ))}
                    </Pie>
                    <Tooltip />
                    <Legend layout="vertical" align="right" verticalAlign="middle" />
                </PieChart>
            </ResponsiveContainer>
        </div>
    );
};

export default Piechart;
